import React from "react"
import { Box as GluestackBox } from "./gluestack/box"

export interface BoxProps extends React.ComponentProps<typeof GluestackBox> {
  className?: string
}

export const Box = ({ children, className, ...props }: BoxProps) => {
  return (
    <GluestackBox className={className} {...props}>
      {children}
    </GluestackBox>
  )
}
